import { render, staticRenderFns } from "./heatMap.vue?vue&type=template&id=545adfa0&scoped=true"
import script from "./heatMap.vue?vue&type=script&lang=js"
export * from "./heatMap.vue?vue&type=script&lang=js"
import style0 from "./heatMap.vue?vue&type=style&index=0&id=545adfa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545adfa0",
  null
  
)

export default component.exports